import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import {
  FulfillmentGroupData,
  shouldUseVerifiedDestinationAddress,
} from "@redotech/redo-fulfillment-group-common/fulfillment-group";

function getPostalCode(row: FulfillmentGroupData, autoCleanAddresses: boolean) {
  if (shouldUseVerifiedDestinationAddress(row, autoCleanAddresses)) {
    return (
      row?.verifiedDestinationAddress?.zip ?? row?.destinationAddress?.zip ?? ""
    );
  }
  return row?.destinationAddress?.zip ?? "";
}

export function getPostalCodeColumnCsvColumn(
  autoCleanAddresses: boolean,
): FulfillmentGroupCsvColumn<FulfillmentGroupData> {
  return {
    header: "Postal code",
    cell: (row: FulfillmentGroupData) => getPostalCode(row, autoCleanAddresses),
  };
}
